import { WalkthroughDocumentStepDto } from './WalkthroughDocumentStepDto';
import { HelpTypeEnum } from './help-type.enum';

export interface HelpDocumentDto {
  id?: number;
  applicationGuid?: string;
  type: HelpTypeEnum;
  reusable: boolean;
  path: string;
  title: string;
  html?: string;
  href?: string;
  /**
   * Page route the walkthrough opens on (e.g. "/time-entry"). When set, the
   * player navigates here before showing step 0 so a tour started from any page
   * lands on its home page first and step 0's element resolves. Mirrors the
   * server WalkthroughDocumentDto.Route. Optional/null for reusable or
   * page-agnostic tours.
   */
  route?: string;
  isPublished: boolean;
  steps?: WalkthroughDocumentStepDto[];
}
